import React, { Component } from 'react';
import Dico from '../../helpers/Dico'
import SliderCriteria from '../std/SliderCriteria';

class DepositSelector extends Component {

    getMessage(i18nKey) { return Dico.getMessage(this.props.context.countryCode, this.props.context.languageCode, i18nKey) }

    handleDepositChange = value => {
        value *= 1.0;
        this.props.onChange(value, this.props.settings);
    }

    buildValueFromAmountKind(parameters, valueMT, valueNbEch, valuePct) {
        if (parameters.depositAmountKind == null) {
            return null;
        }
        switch (parameters.depositAmountKind) {
            case 'MT':
                return valueMT;
            case 'NBECH':
                return valueNbEch;
            default:
                return valuePct;
        }
    }

    render() {
        const parameters = this.props.parameters ? this.props.parameters : {};
        const depositI18nKey = this.buildValueFromAmountKind(parameters, 'generics.unspecified.value', 'calculatorPage.criteria.value.deposit.terms', 'generics.unspecified.value');
        const depositNumType = this.buildValueFromAmountKind(parameters, 'currency', 'integer', 'percent');
        return (
            this.props.deposits != null &&
            <div className="row shadow-sm rounded m-auto">
                <h5 className="text-secondary">{this.getMessage('calculatorPage.criteria.deposit')}</h5>
                <SliderCriteria
                    value={this.props.parameters.deposit}
                    min={this.props.deposits.defaultAdvance === 1 ? 0 : this.props.deposits.min}
                    max={this.props.deposits.max}
                    step={this.props.deposits.step}
                    minStep={this.props.deposits.amountKind === 'MT' ? 50 : 1}
                    values={this.props.deposits.values}
                    i18nKey={depositI18nKey}
                    i18nArgType={depositNumType}
                    onChange={this.handleDepositChange}
                />
            </div>
        );
    }
}
export default (DepositSelector)
